// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  item: "ChartKey__item",
  key: "ChartKey__key",
  note: "ChartKey__note",
  sizePair: "ChartKey__sizePair",
  stacked: "ChartKey__stacked",
  title: "ChartKey__title",
};
